import React, { useMemo } from 'react';
//CarbonComponents
import {
  DataTable,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  SkeletonText,
  TableRow
} from 'carbon-components-react';

interface Props {
  selectedRowHandler: Function;
  title?: string;
  description?: string;
  rows: any[];
  headers?: any[];
  isLoading?: boolean;
  size?: string;
}

const headerKeys = ['externalId', 'job', 'address', 'enquirer', 'status'];

export const DataTableBasicMobileViewCommponent: React.FC<Props> = ({
  selectedRowHandler,
  title,
  description,
  headers,
  rows,
  size
}: any) => {
  const memoizedHeaders = useMemo(() => {
    return headers?.filter((header: any) => headerKeys.includes(header.key));
  }, [headers]);

  return (
    <DataTable
      size={size || 'normal'}
      rows={rows}
      headers={memoizedHeaders || []}
    >
      {({ rows, getRowProps, getTableProps, getTableContainerProps }: any) => (
        <TableContainer
          className="mobile-table"
          title={title}
          description={description}
          {...getTableContainerProps()}
        >
          <Table size={size || 'normal'} {...getTableProps()}>
            <TableBody>
              {rows?.length === 0 ? (
                <React.Fragment>
                  <TableRow>
                    <SkeletonText key={`sm_1`} />
                  </TableRow>
                  <TableRow>
                    <SkeletonText key={`sm_2`} />
                  </TableRow>
                  <TableRow>
                    <SkeletonText key={`sm_3`} />
                  </TableRow>
                </React.Fragment>
              ) : (
                rows.map((row: any, i: any) => {
                  const cells = row.cells;
                  const c_0 = cells[0],
                    c_2 = cells[2],
                    c_4 = cells[4];

                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        {...getRowProps({ row })}
                        onClick={() =>
                          selectedRowHandler && selectedRowHandler(row)
                        }
                      >
                        <TableCell key={cells[i]?.info?.header}>
                          <div className="row--header">
                            {c_0?.value} {c_2?.value ? `(${c_2?.value})` : ''}
                          </div>
                          <div className="row--sub-header">{c_4?.value}</div>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );
};

export default React.memo(DataTableBasicMobileViewCommponent);
